<div class="main">
    <div class="loader" *ngIf="showLoader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">
        <div class="head">
            <div class="label">
                {{'ASSIGNLOAD.title' | translate}}
            </div>
            <img src="assets/popup_close_icon.svg" alt="" (click)="closeDialog();">
        </div>
        <div class="body">
            <div class="top">
                <div class="searchItem">
                    <div class="icon">
                        <img src="assets/search_icon.svg" alt="">
                    </div>
                    <input type="text" placeholder="Search Vehicle No." [(ngModel)]="vehicleNo" (keyup)="getDriverDetails()">
                </div>
                <div class="searchItem">
                    <div class="icon">
                        <img src="assets/search_icon.svg" alt="">
                    </div>
                    <input type="text" placeholder="Search Mobile No." [(ngModel)]="mobileNo" (keyup)="getDriverDetails()">
                </div>
            </div>
            <div class="center">
                <div class="details" *ngFor="let item of details">
                    <div class="label">
                        {{item.label}}
                    </div>
                    <div class="value">
                        {{item.value}}
                    </div>
                </div>
                <div class="details" *ngIf="driverDetails">
                    <div class="label">
                        Desired Weight (Mt)
                    </div>
                    <div class="value">
                        <input type="text" [(ngModel)]="spotVehicleData.desired_weight" style="width: 100px">
                    </div>
                </div>
                <div class="details" *ngIf="driverDetails">
                    <div class="label">
                        Registered For
                    </div>
                    <div class="value">
                        <input type="text" class="formField" required="required" [matAutocomplete]="matRegisterFor"
                          [(ngModel)]="selectedRegisterForName" style="width: 200px" />
                        <mat-autocomplete #matRegisterFor="matAutocomplete"  (optionSelected)='selectRegisterForList($event.option.value)'>
                          <mat-option *ngFor="let register of registerForArr | filter: selectedRegisterForName" [value]="register">
                            <span>{{ register.name }}</span>
                          </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
            </div>

            <div class="bottom" *ngIf="driverDetails">
                <div class="mainButton" (click)="assignLoad();">
                    <div class="button">
                        Assign
                    </div>
                </div>
            </div>

            <!-- <div class="left">
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.driverName' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.name">
                    <div class="check" style="height: 0px;">
                        <mat-checkbox style="font-size: 12px;width: 15px;height: 15px;"
                            [(ngModel)]='spotVehicleData.has_smart_phone'>{{'ASSIGNLOAD.hasSmartPhone' |
                            translate}}</mat-checkbox>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.vehicleNum' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.vehicle_number" [placeholder]="vehicle_pattern">
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.license' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
                        <small class="smallLink" *ngIf="showVerifyLinks"
                            (click)="openVerifyModal('https://parivahan.gov.in/rcdlstatus/?pur_cd=101')">({{'ASSIGNLOAD.verifyLicense'
                            |
                            translate}})</small>

                    </div>
                    <input [(ngModel)]="spotVehicleData.driver_licence_no" type="text" />
                </div>
                <div style="display:inline-flex;" *ngIf="spinner">
                    <span>
                        <mat-spinner [diameter]="20" style="position: relative;top: 30px;"></mat-spinner>
                    </span>
                </div>
                <div class="inputContainer" style="margin-top: 10px;">
                    <div class="label">
                        {{'ASSIGNLOAD.carrierType' | translate}}
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField"
                            style="height: 100%;background-color: #fff;border: solid 1px #e3e3e3; border-radius: 5px; padding: 4px;width:100%"
                            [(ngModel)]="carrier_type">
                            <mat-option *ngFor="let type of carrierTypes" [value]="type">
                                {{type}}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="formElement" *ngIf="showGPSProvider && assetsArray && assetsArray.length">
                    <div class="formLabel">
                        {{'ADD_VEHICLE.asset' | translate}}
                    </div>
                    <div class="formInput">
                        <input class="form-input" type="text" (keyup)="applyFilter($event.target.value)"
                            [matAutocomplete]="auto_assets" [(ngModel)]="selectedAsset">
                        <mat-autocomplete #auto_assets="matAutocomplete">
                            <mat-option *ngFor="let asset of assets" [value]="asset.reg_number"
                                (click)="selectAsset(asset)">
                                <span>
                                    {{asset.reg_number}}
                                </span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.vehicle_qty' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
                        (MT)


                    </div>
                    <input [(ngModel)]="capacityData.vehicle_qty" (keyup)="sub($event.target.value)" type="text" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.rc_Laden_weight' | translate}} <sup
                            style="color: #E54131; font-weight: 900;">*</sup> (MT)
                    </div>
                    <input [(ngModel)]="capacityData.rc_Laden_weight" (keyup)="sub($event.target.value)" type="text"
                        autocomplete="off" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.preferred_zone' | translate}}
                    </div>
                    <div class="input_dropdown">
                        <input type="text" class="formField" required="required" [matAutocomplete]="orgPlace"
                            [(ngModel)]="spotVehicleData.preferred_zone">
                        <mat-autocomplete #orgPlace="matAutocomplete">
                            <mat-option *ngFor="let org of states | filter:spotVehicleData.preferred_zone"
                                [value]="org.name">
                                <span>{{org.name}}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.location' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.preferred_location" autocomplete="off">
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "ASSIGNLOAD.customer_name" | translate
                        }}
                    </div>
                    <input type="text" [(ngModel)]="customer_name" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "ASSIGNLOAD.insuranceno" | translate
                        }}
                    </div>
                    <input type="number" min="0" [(ngModel)]="insurance.no" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "ASSIGNLOAD.engineno" | translate
                        }}
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.engine_number" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.gps_provider' | translate}}
                    </div>
                    <input type="text" [(ngModel)]="selectedGPSProvider" disabled="true" />
                    <div class="add_btn" (click)="fetchGps();">
                        <div class="button">
                            {{'ASSIGNLOAD.fetch' | translate}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.mobileNum' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.mobile">
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.vehicleType' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField"
                            style="height: 100%;background-color: #fff;border: solid 1px #e3e3e3; border-radius: 5px; padding: 4px;width:100%"
                            [(ngModel)]="selectedVehicle">
                            <mat-option *ngFor="let vehicle of allVehicles" [value]="vehicle._id">
                                {{ vehicle.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.licenseExpiryDate' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="formInput">
                        <input type="text" name="expiryDate" [matDatepicker]="picker" [(ngModel)]="expiryDate"
                            (click)="picker.open()" />
                        <mat-datepicker #picker
                            (closed)="setExpiryDate(expiryDate, 'change','licence_expiry')"></mat-datepicker>
                    </div>
                </div>
               
                <div class="dedicate_list">
                    <div class="vehicle_shipper">
                        <span class="dedicate_text" style="font-size: 13px;">{{'ASSIGNLOAD.dedicatedTo' | translate}}</span>
                    </div>
                    <div class="inputContainer">
                        <input type="text" class="formField" required="required" [matAutocomplete]="matdedicated"
                            [(ngModel)]="dedicatedName" />
                        <mat-autocomplete #matdedicated="matAutocomplete"
                            (optionSelected)='selectdedicated($event.option.value)'>
                            <mat-option *ngFor="let shipper of dedicatedShippersArr | filter: dedicatedName" [value]="shipper">
                                <span>{{ shipper.name }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="dedicate_list">
                    <div class="vehicle_shipper">
                        <span class="dedicate_text" style="font-size: 13px;margin-top: 0;">{{'ASSIGNLOAD.registeredFor' | translate}}<sup
                                style="color: #ff0000;">*</sup></span>
                    </div>
                  
                    <div class="inputContainer">
                        <input type="text" class="formField" [disabled]="enbleregisterfor" required="required" [matAutocomplete]="matRegisterFor"
                          [(ngModel)]="selectedRegisterForName" />
                        <mat-autocomplete #matRegisterFor="matAutocomplete"  (optionSelected)='selectRegisterForList($event.option.value)'>
                          <mat-option *ngFor="let register of registerForArr | filter: selectedRegisterForName" [value]="register">
                            <span>{{ register.name }}</span>
                          </mat-option>
                        </mat-autocomplete>
                      </div>
                   
                </div>

                <div *ngFor="let mat of materialList; let last = last; let i = index; let first = first;">
                    <div class="material_sec">
                        <div class="add_material">
                            <div class="inputContainer">
                                <div class="label">
                                    {{ "Materials" | translate }}
                                </div>
                                <mat-select
                                    style="border: solid 1px #e3e3e3;padding: 4px;  border-radius: 5px;   align-items: center;"
                                    [(ngModel)]="mat.name" class="formField" required="required"
                                    [disabled]="enbleMaterial">
                                    <mat-option *ngFor="let mater of materialsArr"
                                        (onSelectionChange)="selectMaterial(mat, $event,i)" [value]="mater.name">
                                        {{mater.name}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="add_load">
                            <div class="inputContainer">
                                <div class="label">
                                    {{ "Load" | translate }}
                                </div>
                                <input [(ngModel)]="mat.load" [disabled]="enbleMaterial" type="text"
                                    autocomplete="off" />
                            </div>
                        </div>
                        <div class="material_action">
                            <div *ngIf="!first" (click)="removeMaterial(i)">
                                <img src="assets/del.svg" alt="">
                            </div>
                            <div *ngIf="last && mat.name" (click)="addMaterial()">
                                <img src="assets/plus.svg" alt="">
                            </div>
                        </div>
                    </div>
                 
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.capacity' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
                        (MT)


                    </div>
                    <input [(ngModel)]="capacityData.capacity" type="text" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{ "ASSIGNLOAD.desired_weight" | translate }}<sup
                            style="color: #E54131; font-weight: 900;">*</sup> (MT)
                    </div>
                    <input [(ngModel)]="capacityData.desired_weight" type="text" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.comments' | translate}}


                    </div>
                    <input [(ngModel)]="comments" type="text" />
                </div>
                <div class="inputContainer" *ngIf="showGPSProvider && assetsArray && assetsArray.length">
                    <div class="label">
                        {{'ASSIGNLOAD.asset' | translate}}
                    </div>
                    <input type="text" (keyup)="applyFilter($event.target.value)" [matAutocomplete]="auto_assets"
                        [(ngModel)]="selectedAsset">
                    <mat-autocomplete #auto_assets="matAutocomplete">
                        <mat-option *ngFor="let asset of assets" [value]="asset.reg_number"
                            (click)="selectAsset(asset)">
                            <span>
                                {{asset.reg_number}}
                            </span>
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.insuranceexpirydate' | translate}}<span><sup
                                style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="formInput">
                        <input type="text" name="invExpiryDate" [matDatepicker]="insuPicker"
                            [(ngModel)]="insurance.expiry" (click)="insuPicker.open()"
                            (closed)="setExpiryDate(expiryDate, 'change','invExpiry')" autocomplete="off" />
                        <mat-datepicker #insuPicker></mat-datepicker>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.chassisno' | translate}}
                    </div>
                    <input [(ngModel)]="spotVehicleData.chassis_number" type="text" />
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'ASSIGNLOAD.language' | translate }}
                    </div>
                    <div class="dialog_body">
                        <mat-select
                            style="border: solid 1px #e3e3e3;height: 30px;  border-radius: 5px;   align-items: center;"
                            class="inputSelect">

                            <mat-option *ngFor="let language of language" [value]="language" (click)="language">
                                {{language.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div class="submit_btns">
                <div class="add_btn" (click)="assignLoad();">
                    <div class="button">
                        {{'ASSIGNLOAD.assign_load' | translate}}
                    </div>
                </div>
          
            </div> -->
        </div>
    </div>
</div>